const updateRadioGroup = (_control: any, value: any): boolean =>
  Boolean(Number(value));

export default updateRadioGroup;
